import { gql } from '@apollo/client';
import { CallToActionBlock } from './call-to-action-block';
import { Promotion } from './promotion';

export const Offer = gql`
    fragment Offer on OfferRecord {
        __typename
        title
        subtitle
        promotions {
            ...Promotion
        }
        callToActions {
            ...CallToActionBlock
        }
    }
    ${Promotion}
    ${CallToActionBlock}
`;
